import { Injectable } from '@angular/core';

const SESSION_SCOPE_KEY = 'farmnet.activatedFeatures';

@Injectable({
    providedIn: 'root'
})
export class FeatureToggleService {

    isFeatureActivated(identifier: string) {
        const features = this.getActivatedFeaturesFromStorage();
        return features.includes(identifier);
    }

    private getActivatedFeaturesFromStorage(): string[] {
        const value = sessionStorage.getItem(SESSION_SCOPE_KEY);
        if (value) {
            return JSON.parse(value);
        }
        return [];
    }

}
